import styles from './styles.less';
import { kebabCase } from 'lodash';


const ShowRating = (props) => (
    <div
        className={ cx(styles.root, props.className) }
        style={{ backgroundImage: `url(http://i.cdn.turner.com/adultswim/adultswimtv/tools/img/global/rating-icons/${kebabCase(props.rating)}.gif)` }}
    />
);


export default ShowRating;



/** WEBPACK FOOTER **
 ** ./src/common/components/show-rating/index.js
 **/